module.exports = __webpack_public_path__ + "9c5a9dcee28c795d0bdaabb29fc735bc.png";